import React, { useEffect, useState } from "react";
import { sideActionsRV, typeMoneyDescription } from "../Utils/constants";
import IconTableDown from "../Resources/svg/Icons/IconTableDown";
import { API } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Loading from "./loading";
import ModalAlertLocationCode from "./ModalAlertLocationCode";

export const CardModality = ({
  collapseState,
  modality,
  cardId,
  actionSideQuote,
  setSelectedModality,
  state,
  nroOperacion,
  respuestaECM,
  affiliate,
}: any) => {
  const [collapse, setCollapse] = useState(false);
  const history = useHistory();
  const [loadingState, setLoadingState] = useState(false);
  const [showLocationCodeAlert, setShowLocationCodeAlert] = useState(false);

  const cleanModality = (obj: any) => {
    if (!obj) return obj;
    const cleaned: any = {};
    Object.keys(obj).forEach((key) => {
      if (isNaN(Number(key)) || key.includes('_') || key.includes('.')) {
        cleaned[key] = obj[key];
      }
    });
    return cleaned;
  };

  const {
    modalidad,
    moneda,
    periodoGarantizado,
    anosRT,
    nroCotizacion,
    respuestaMacro,
    resultadoEESS,
    procesoEmision = false,
  } = modality;

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  const callToEmitter = async () => {
    const affiliateHasLocationCode = affiliate && affiliate.departamento && affiliate.provincia && affiliate.distrito;
    if (!affiliateHasLocationCode) {
      setShowLocationCodeAlert(true);
      return;
    }

    setLoadingState(true);
    const payload = {
      payload: {
        ids: [
          {
            id: String(nroOperacion),
          },
        ],
      },
    };

    const request = {
      body: payload,
      headers: {},
    };

    try {
      await API.post("api-vitalicias", "/solicitud/emisionRV", request)
        .then((response) => {
          setLoadingState(false);
          console.log(response, "response from emitter");
          history.push("/cotizaciones", { from: history.location.pathname });
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    } catch (ex) {
      console.log("ex", ex);
    }
  };

  const moneyTypeDescriptionList: any = typeMoneyDescription;
  useEffect(() => {
    if (cardId !== 0) return;
    setCollapse(true);
  }, [cardId]);

  useEffect(() => {
    setCollapse(true);
  }, [collapseState]);

  const itemsCollapse = [
    { label: "Modalidad", value: modalidad },
    { label: "Diferimiento", value: anosRT },
    { label: "Garantizado", value: periodoGarantizado },
    { label: "Moneda", value: moneyTypeDescriptionList[moneda] },
    { label: "N° Cotización", value: nroCotizacion },
  ];

  return (
    <div className="card-verify__beneficiary" style={{ position: "relative" }}>
      <div className="clientForm__beneficiary-box-icon">
        <div className="clientForm__beneficiary" style={{ margin: "0" }}>
          Modalidad {cardId + 1}
        </div>
      </div>
      <div className={`card-table__icon`} onClick={handleCardStateTable}>
        <IconTableDown className={`${collapse ? "up" : "down"}`} />
      </div>

      {collapse && (
        <>
          {itemsCollapse &&
            itemsCollapse.map((item, index) => (
              <div className="card-verify__body" key={index}>
                <div className="card-verify__quote">{item.label}:</div>
                <div className="card-verify__data">{item.value}</div>
              </div>
            ))}
          {respuestaMacro && (
            <div className="card-verify__body">
              <div className="card-verify__quote">Estado:</div>
              <div className="card-verify__data">{respuestaMacro.cotiza}</div>
            </div>
          )}
          <div className="clientForm__beneficiary-box-with-icon-button">
            {!resultadoEESS && (
              <>
                <button
                  className="btn is-secondary is-small"
                  onClick={() => {
                    setSelectedModality({ ...cleanModality(modality), indice: cardId });
                    actionSideQuote(sideActionsRV.DETALLE_MODALIDAD);
                  }}
                >
                  Ver
                </button>
                {!(
                  state === "recalculado" ||
                  state === "emitida" ||
                  state === "ganado" ||
                  state === "anulado"
                ) && (
                  <button
                    className="btn is-secondary is-small"
                    onClick={() => {
                      setSelectedModality({ ...cleanModality(modality), indice: cardId });
                      actionSideQuote(sideActionsRV.MEJORAR_MODALIDAD);
                    }}
                  >
                    Mejorar
                  </button>
                )}{" "}
              </>
            )}
            {resultadoEESS && (
              <button
                className="btn is-secondary is-small"
                onClick={() => {
                  setSelectedModality({ ...cleanModality(modality), indice: cardId });
                  actionSideQuote(sideActionsRV.DETALLE_MODALIDAD);
                }}
              >
                Ver
              </button>
            )}
            {state !== "emitida" && state !== "anulado" && (
              <button
                className="btn is-secondary is-small"
                onClick={() => {
                  setSelectedModality({ ...cleanModality(modality), indice: cardId });
                  actionSideQuote(sideActionsRV.RECALCULAR_MODALIDAD);
                }}
              >
                Recalcular
              </button>
            )}
            {respuestaECM && respuestaECM.cartaAFP && 
              ['emitida', 'cartaEnviada', 'datosActualizados', 'enviadoEmision', 'recalculado', 'ganado'].includes(state) && (
              <button
                className="btn is-secondary is-small"
                onClick={() => window.open(respuestaECM.cartaAFP.documents.fileUrl, "_blank")}
              >
                Carta AFP
              </button>
            )}
            {state === "recalculado" &&
              state !== "emitida" &&
              !procesoEmision && (
                <>
                  <button
                    className="btn is-secondary is-small"
                    onClick={() => callToEmitter()}
                  >
                    Emitir
                  </button>
                </>
              )}
          </div>
        </>
      )}
      {loadingState && <Loading />}
      <ModalAlertLocationCode open={showLocationCodeAlert} onClose={() => setShowLocationCodeAlert(false)} />
    </div>
  );
};
